import type { UserRole } from '../types/crm';
import type { DemAppUserRole } from '../types/dem';
import { normalizeUserRole } from './settingsPermissions';

export function canAccessDemSettings(role: UserRole): boolean {
  const normalized = normalizeUserRole(role);
  return normalized === 'admin' || normalized === 'it';
}

/** Admin and IT can view integration cards; secrets are always masked as ******. */
export function canViewDemIntegrationSecrets(role: UserRole): boolean {
  return canAccessDemSettings(role);
}

/** Only IT may reveal and edit DEM integration secret fields. */
export function canRevealDemIntegrationSecrets(role: UserRole): boolean {
  return normalizeUserRole(role) === 'it';
}

export function canManageDemAppUsers(role: UserRole): boolean {
  return canAccessDemSettings(role);
}

export function canEditDemAppUser(actorRole: UserRole, targetRole: DemAppUserRole): boolean {
  const actor = normalizeUserRole(actorRole);
  const target = targetRole.toLowerCase() as DemAppUserRole;
  if (actor === 'it') return true;
  if (actor === 'admin') return target !== 'it';
  return false;
}

export function assignableDemAppUserRoles(actorRole: UserRole): DemAppUserRole[] {
  const actor = normalizeUserRole(actorRole);
  if (actor === 'it') return ['user', 'admin', 'it'];
  if (actor === 'admin') return ['user', 'admin'];
  return [];
}
